import React, { FC } from "react"

const ContentManagement: FC = () => {
  return <div>Content Management</div>
}
export default ContentManagement
